<template>
  <label style="width: fit-content">
    <input :type="type"
           @focusin="focuse = true"
           @focusout="focuse = false"
           class="inp-text"
           v-model="value"
           :maxlength="maxlength"
           @input="setValue"
           :class="{
              'active' : focuse === true ,
              'not-active' : focuse === false ,
              'error' : error === true ,
              'address' : address,
              'bank': bank,
              'auth' : auth

           }"
    >

    <span
        :class="{
        'active-placeholder' : focuse === true ,
        'not-active-placeholder' : focuse === false ,
        'error-placeholder' : error === true,
         'empity':value !== ''
      }"
    >
      {{ placeholder }}
    </span>

    <inline-svg  @click="$emit('showPassword')"
                 class="logo"  v-if="passwordlogo === true"
                 :src="require('../../assets/icon/input/password.svg') "
                 :class="{
                     'active-logo' : focuse === true ,
                     'not-active-logo' : focuse === false ,
                     'error-logo' : error === true ,
                 }"
    />
    <inline-svg  class="logo" v-if="emaillogo === true"
                 :src="require('../../assets/icon/input/email.svg') "
                 :class="{
                     'active-logo' : focuse === true ,
                     'not-active-logo' : focuse === false ,
                     'error-logo' : error === true ,
                 }"
    />
    <inline-svg  class="logo" v-if="calenderlogo === true"
                 :src="require('../../assets/icon/input/calender.svg') "
                 :class="{
                     'active-logo' : focuse === true ,
                     'not-active-logo' : focuse === false ,
                     'error-logo' : error === true ,
                 }"
    />
  </label>
</template>

<script>
export default {
  name: "custom-input",
  props: ['passwordlogo', 'emaillogo', 'calenderlogo', 'placeholder' , 'type' , 'address','bank','auth','maxlength' ,'typeValue' , 'disabled' ,'readonly' , 'data'],
  data() {
    return {
      focuse: false,
      error: false,
      value: ''
    }
  },

  methods: {
    setValue() {
      this.$emit('getValue', this.value)
      this.setType()
    },
    setType(){


      if(this.typeValue =='text'){
        this.value = this.$S2Fa(this.value)
      }
     else  if(this.typeValue=='number'){
        this.value = this.$A2N(this.value)
      }
     else return

    }
  }
}
</script>

<style lang="scss" scoped>
.active-logo{
  fill:#1199FA !important;
}

.not-active-logo{
  fill:#8C8585 !important;
}

.error-logo{
  fill:#D94F68 !important;
}
label {
  position: relative;
  transition: top 0.3s , font-size 0.3s;
  height: 100%;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;

  input:hover{
    border: 1px solid #FFFFFF;
  }

  .logo{
    position: absolute;
    left: 10px;
    cursor: pointer;
  }

  .input {
    height: 48px;
    width:318px;
    border-radius: 8px;
    color: #8C8585;
  }

  .inp-text{
    padding-right: 10px;
    //font-family: cursive;
    font-weight:bold;
  }

  .address{
    width: 694px;
  }

  .bank{
    width: 180px;
  }

  .auth{
    width: 370px;
  }

  .placeholder {
    position: absolute;
    top: 3px;
    right: 8px;
    font-size: 12px;
    transition: top 0.3s , font-size 0.3s;
  }

  .not-active {
    @extend .input;
    border: 1px solid #8C8585;
  }

  .empity{
    display: none !important;
  }

  .active-placeholder {
    @extend .placeholder;
    color: #1199FA;
    font-size: 10px;
  }

  .not-active-placeholder {
    @extend .placeholder;
    color: #8C8585;
    top: 30% !important;
  }

  .error-placeholder {
    @extend .placeholder;
    color: #D94F68;
    font-size: 10px;
  }

  .active {
    @extend .input;
    border: 1px solid #1199FA !important;
  }

  .error {
    @extend .input;
    border: 1px solid #D94F68;
  }
}

@media(max-width: 460px){
  .input{
    max-width: 295px !important;
  }

  .address{
    max-width: 295px !important;
  }
}

@media(max-width: 401px) and (min-width: 361px){
  .input{
    max-width: 221px !important;
  }
}

@media(max-width: 500px) and (min-width: 460px){
  .input{
    max-width: 293px !important;
  }
}

@media(max-width: 992px){
  .address{
    max-width: 305px !important;
  }
}

@media(max-width: 360px){
  .input{
    max-width: 220px !important;
  }

  .address{
    max-width: 220px !important;
  }
}
</style>